import { render, staticRenderFns } from "./AddModule.vue?vue&type=template&id=2eefb08c&"
import script from "./AddModule.vue?vue&type=script&lang=js&"
export * from "./AddModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports